import React, { useMemo } from 'react';
import { Layout, Tabs } from 'tea-component';
import { connect, useIntl } from 'umi';

import useTabHistory from '@op/hooks/useTabHistory';
import MainContent from './MainContent';
import ContentBody from '@op/components/ContentBody';
import {
  compareRankingsGameLevelUpTips,
  compareRankingsMobileGameTips,
} from '@op/components/BubbleCommon';
import levelupIcon from '@op/assets/svg/levelup.svg';
import './index.scss';
import { useRequestFontWebConfig } from '@op/hooks/useFrontWebConfig';
import ChannelShareRankingPointInfo from '@op/operationLog/pages/channelShareRanking';
import {
  buriedBtnPoint,
  useInitBuriedPointInfo,
} from '@op/operationLog/buriedPoint';

const { Content } = Layout;

function channelShareRanking({ whileGameInfo, gameInfo }: any) {
  const { formatMessage } = useIntl();
  const { tab, onActive } = useTabHistory({
    defaultValue: 'total',
  });
  useInitBuriedPointInfo({ buriedPoint: ChannelShareRankingPointInfo });

  useRequestFontWebConfig({
    keys: [{ key: 'ai_prompt_list' }],
    gameInfo,
  });

  const tabs = useMemo(
    () => [
      {
        id: 'total',
        label: formatMessage({ id: 'Total' }),
      },
      {
        id: 'mobile',
        label: formatMessage({ id: 'Mobile Games' }),
      },
      {
        id: 'pc_console',
        label: formatMessage({ id: 'PC/Console Games' }),
      },
    ],
    [formatMessage],
  );

  return (
    <Content className="dbo-page dbo-channel-share-ranking-wrapper">
      <ContentBody
        className="dbo-channel-share-raking"
        horseRaceLampTips={
          tab === 'pc_console'
            ? compareRankingsGameLevelUpTips
            : [compareRankingsGameLevelUpTips, compareRankingsMobileGameTips]
        }
        contentHeard={
          <Content.Header
            className="dbo-header contentHead-normal"
            title={formatMessage({ id: 'Market Popularity Ranking' })}
            subtitle={
              <div className="dbo-header-subtitle ">
                {formatMessage(
                  {
                    id: 'All data below sourced from {Levelup} with 1 day delay (T-1)',
                  },
                  {
                    Levelup: (
                      <img
                        style={{ width: 60, marginLeft: 5, marginRight: 5 }}
                        src={levelupIcon}
                      ></img>
                    ),
                  },
                )}{' '}
              </div>
            }
          >
            {/* 注释 tab 也要 去掉  dbo-header后面 contentHead-normal 类名  */}
            <div className="header-tab">
              <Tabs
                ceiling
                tabs={tabs}
                animated={false}
                activeId={tab}
                onActive={(tab) => {
                  onActive(tab);
                  buriedBtnPoint('SwitchGameType', { game_type: tab.id });
                }}
              />
            </div>
          </Content.Header>
        }
      >
        {tab === 'total' ? (
          <MainContent
            gameInfo={gameInfo}
            key={'total'}
            tab={tab}
            params={{ game_types: [] }}
            filterParams={[]}
          ></MainContent>
        ) : tab === 'mobile' ? (
          <MainContent
            gameInfo={gameInfo}
            key={'mobile'}
            tab={tab}
            filterParams={['mobile']}
            params={{ game_types: ['mobile'] }}
          ></MainContent>
        ) : (
          <MainContent
            gameInfo={gameInfo}
            key={'pc_console'}
            tab={tab}
            filterParams={['pc', 'console']}
            params={{ game_types: ['pc_console'] }}
          ></MainContent>
        )}
      </ContentBody>
    </Content>
  );
}

export default connect((state: any) => {
  const { opinionCommon } = state;
  return {
    gameInfo: opinionCommon.gameInfo,
    whileGameInfo: opinionCommon.whileGameInfo,
  };
})(channelShareRanking);
